module.exports = __webpack_public_path__ + "img/logo.5d759f27.svg";